
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { StepItemProps } from ".";
import { loading, endLoading } from "store/step";

interface ApiStepRemoveInputProps {
    ids: number[]
}

type ApiStepRemoveOutputProps = OutputBaseProps<{ item: StepItemProps; }>

export const apiStepRemove = async (data: ApiStepRemoveInputProps, workflowId: number) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiStepRemoveOutputProps>(`/api/workflow/${workflowId}/step/remove`, { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};